import { createThemedComponent } from '../util/createThemedComponent';
export var Badge = createThemedComponent(['variant', 'size', 'badgeStyle'], {
    variant: 'grey',
    badgeStyle: 'normal',
    themeKey: 'badges',
    sx: {
        whiteSpace: 'nowrap',
        display: 'inline-block',
        px: 2,
        fontSize: 1,
    },
});
//# sourceMappingURL=Badge.js.map